import React, { useState, useEffect } from 'react';
import { useMutation, useQuery, gql } from '@apollo/client';
import { useAuth0 } from '@auth0/auth0-react';

const GET_USUARIOS = gql`
query getUsuarios{
    getUsuarios{
        _id
        nombre
        rol
        contacto
        correo
        direccion

    }
}`

const CREAR_USUARIO = gql`
mutation crearUsuario($nombre:String, $rol:String, $contacto: String, $correo:String, $direccion:String){
    crearUsuario(nombre: $nombre, rol:$rol, contacto:$contacto, correo:$correo, direccion:$direccion){
        _id
        nombre
        rol
        contacto
        correo
        direccion
    }
}`

const ELIMINAR_USUARIO = gql`
mutation eliminarUsuario($id: ID!){
    eliminarUsuario(_id:$id)
}`

const ACTUALIZAR_USUARIO = gql`
mutation editarUsuario($id: ID!, $nuevoNombre: String, $nuevoRol: String, $nuevoContacto: String, $nuevaDireccion: String, $nuevoCorreo:String){
    editarUsuario(_id: $id, nombre:$nuevoNombre, rol:$nuevoRol, contacto: $nuevoContacto, direccion: $nuevaDireccion, correo:$nuevoCorreo){
        _id
        nombre
        rol
        contacto
        correo
        direccion
    }
}`

function CrearUsuarios (){

  
  const {user, isAuthenticated, loginWithRedirect,logout } = useAuth0();
  const {loading, error, data} = useQuery(GET_USUARIOS);
  const [isAdmin, setIsAdmin] = useState(false);
  
 
  
    
    const [editingUsuario, setEditingUsuario] = useState(null);
    const [nuevoNombre, setNuevoNombre] = useState('');
    const [nuevoRol, setNuevoRol] = useState('');
    const [nuevoContacto, setNuevoContacto] = useState('');
    const [nuevoCorreo, setNuevoCorreo] = useState('');
    const [nuevaDireccion, setNuevaDireccion] = useState('');
    const [editarUsuario] = useMutation(ACTUALIZAR_USUARIO);


    const [nombre, setNombre] = useState('');
    const [rol, setRol]= useState('');
    const [contacto, setContacto] = useState('');
    const [correo, setCorreo] = useState('');
    const [direccion, setDireccion] = useState('');
    const [crearUsuario] =useMutation(CREAR_USUARIO, {
      refetchQueries: [{ query: GET_USUARIOS }],  
    });

    useEffect(() => {
      if (!loading && isAuthenticated && data && user) {
        const isAdminUser = data.getUsuarios.find(usuario => usuario.correo === user.email && usuario.rol === "administrador");
        setIsAdmin(isAdminUser !== undefined);
      }
    }, [loading, data, isAuthenticated, user]);

    const usuarioSubmit = e =>{
        crearUsuario({variables:{nombre,rol, contacto, correo, direccion}});
        setNombre('');
        setRol('');
        setContacto('');
        setCorreo('');
        setDireccion('');
     }

     const [eliminarUsuario] = useMutation(ELIMINAR_USUARIO, {
        refetchQueries: [{ query: GET_USUARIOS}]
      });

     

      if (!isAuthenticated) {
        return <div class="alert alert-success" role="alert">
        No tienes permisos  para acceder a esta página. 
      </div>
      }
      
      if (loading) return <p>Esperando resultados...</p>;
      if (error) return <p>Error</p>;
      const reversedData = data.getUsuarios.slice().reverse();


    
    return(

<div>
  
<div class="card card-salida" >
    <div class="card-body">
      <h2 class="card-title">Agregar producto</h2>
      <form onSubmit={usuarioSubmit}>
        <h6>Nombre</h6>
        <input  placeholder='nombre' value={nombre} onChange={evt=>setNombre(evt.target.value)}></input>
    <h6>Rol</h6>
    <input  placeholder='Rol' value={rol} onChange={evt=>setRol(evt.target.value)}></input>
    <h6>Contacto</h6>
    <input  placeholder='Contacto' value={contacto} onChange={evt=>setContacto(evt.target.value)}></input>
    <h6>Dirección</h6>
    <input  placeholder='Dirección' value={direccion} onChange={evt=>setDireccion(evt.target.value)}></input>
    <h6>Correo</h6>
    <input  placeholder='correo' value={correo} onChange={evt=>setCorreo(evt.target.value)}></input>
    <button className="btn btn-salida">Agregar usuario</button>
        
      </form>
      </div>
      </div>

      <div class="container">
  <div className="row"> 
  {reversedData.map((usuario)=>(
   <>
   <div className="card card-entrada col-xs-12 col-xl-4 col-sm-6" >
        <div className="card-body">
<h1>{usuario.nombre}</h1>
<h5>{usuario.rol}</h5>
<h5>{usuario.correo}</h5>
<button className="btn btn-danger" onClick={()=>{
            eliminarUsuario({ variables:{id:usuario._id} });
          }}  disabled={loading}>
          eliminar
           </button>

           {editingUsuario === usuario._id ? (
  <>
  <p>Usuario</p>
   <input
  type="text"
  value={nuevoNombre}
  onChange={(e) => setNuevoNombre(e.target.value)}
/>
<p>rol</p>
   <input
  type="text"
  value={nuevoRol}
  onChange={(e) => setNuevoRol(e.target.value)}
/>
<p>Contacto</p>
   <input
  type="text"
  value={nuevoContacto}
  onChange={(e) => setNuevoContacto(e.target.value)}
/>
  <p>Direccion</p>
  <input
  type="text"
  value={nuevaDireccion}
  onChange={(e) => setNuevaDireccion(e.target.value)}
/>
<p>Correo</p>
<input
  type="text"
  value={nuevoCorreo}
  onChange={(e) => setNuevoCorreo(e.target.value)}
/>
<button
className="btn btn-primary"
onClick={() => {
  editarUsuario({
    variables: { id: usuario._id,nuevoNombre, nuevoRol, nuevaDireccion, nuevoContacto, nuevoCorreo },
  });
  setEditingUsuario(null);
  setNuevoNombre('')
  setNuevoRol('');
  setNuevoContacto('');
  setNuevaDireccion('');
  setNuevoCorreo('');
  
}}
>
Guardar
</button>
</>
): (
  <>
    
    <button
      className="btn btn-primary"
      onClick={() => {
        setEditingUsuario(usuario._id);
        setNuevoNombre(usuario.nombre);
        setNuevoRol(usuario.rol);
        setNuevoContacto(usuario.contacto);
        setNuevaDireccion(usuario.direccion);
        setNuevoCorreo(usuario.correo);
      }}


    >
      Editar
    </button>
  </>
)}
        </div>
        </div>
   </>
  ))}
  </div>
  </div>
</div>
    );

}

export default CrearUsuarios;